import Icon from "../../../components/AppIcon";
import { ProjectType } from "../types";

interface ProjectTypeSelectorProps {
  types: ProjectType[];
  selectedType: string;
  onSelect: (id: string) => void;
}

const ProjectTypeSelector = ({
  types,
  selectedType,
  onSelect,
}: ProjectTypeSelectorProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {types.map((type) => (
        <button
          key={type.id}
          onClick={() => onSelect(type.id)}
          className={`p-4 rounded-lg border-2 transition-all duration-300 text-left ${
            selectedType === type.id
              ? "border-primary bg-primary/10" :"border-border bg-surface hover:border-primary/50"
          }`}
        >
          <div className="flex items-center gap-3 mb-2">
            <div
              className={`p-2 rounded-md ${
                selectedType === type.id
                  ? "bg-primary text-primary-foreground"
                  : "bg-muted"
              }`}
            >
              <Icon name={type.icon} size={20} />
            </div>
            <h4 className="font-semibold text-foreground">{type.name}</h4>
          </div>
          <p className="text-sm text-muted-foreground">{type.description}</p>
        </button>
      ))}
    </div>
  );
};

export default ProjectTypeSelector;